import {
  RESET_REPORTING_STORE,
  SET_REPORTING_GROUPS,
  SET_REPORTING_GROUP,
  SET_REPORTING_CUSTOMER,
  SET_REPORTING_GUIDE_TOUR_CUSTOMERS,
  SET_REPORTING_GUIDE_TOUR_GROUPS,
  SET_REPORTING_GROUPS_LOADING,
  SET_EDITOR_VARIABLES
} from "./constants";


export const resetReportingStore = () => {
  return {
    type: RESET_REPORTING_STORE
  }
};

export const setReportingGroups = (groups) => ({
  type: SET_REPORTING_GROUPS,
  groups
});

export const setReportingGroup = (group) => ({
  type: SET_REPORTING_GROUP,
  group
});

export const setReportingCustomer = (customer) => ({
  type: SET_REPORTING_CUSTOMER,
  customer
});

export const setReportingGuideTourCustomers = (customers) => ({
  type: SET_REPORTING_GUIDE_TOUR_CUSTOMERS,
  customers
});

export const setReportingGuideTourGroups = (groups) => ({
  type: SET_REPORTING_GUIDE_TOUR_GROUPS,
  groups
});

export const setReportingGroupsLoading = (loading) => ({
  type: SET_REPORTING_GROUPS_LOADING,
  loading
});

export const setEditorVariables = (variables) => ({
  type: SET_EDITOR_VARIABLES,
  variables
});
